"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _NumberIncrement = _interopRequireDefault(require("elevate-ui/NumberIncrement"));

var _Typography = _interopRequireDefault(require("elevate-ui/Typography"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Padding = function Padding(_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    type: "heading6",
    className: classes.headline
  }, "Padding"), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.grid
  }, /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "paddingTop",
    name: "paddingTop",
    label: "Top",
    component: _NumberIncrement["default"],
    min: "0"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "paddingRight",
    name: "paddingRight",
    label: "Right",
    component: _NumberIncrement["default"],
    min: "0"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "paddingLeft",
    name: "paddingLeft",
    label: "Left",
    component: _NumberIncrement["default"],
    min: "0"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "paddingBottom",
    name: "paddingBottom",
    label: "Bottom",
    component: _NumberIncrement["default"],
    min: "0"
  })));
};

var styles = function styles() {
  return {
    hide: {
      display: "none"
    },
    headline: {
      display: "flex",
      justifyContent: "flex-start",
      flexFlow: "row nowrap",
      alignItems: "center"
    },
    grid: {
      display: "grid",
      justifyItems: "center",
      alignItems: "center",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      gridGap: "16px"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "Padding"
})(Padding);

exports["default"] = _default;